export default __webpack_public_path__ + "8822cbb4fdd25c682dd707715e2d497f.png";